import { createAction } from "@reduxjs/toolkit";
import type { SignAttendanceSheetBody, SignAttendanceSheetResponse } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const signStudentAttendanceSheet = createApiThunk<SignAttendanceSheetResponse, SignAttendanceSheetBody>(
  "student/signAttendanceSheet",
  async (payload: SignAttendanceSheetBody, { extra: { studentRepository } }) => {
    return studentRepository!.signAttendanceSheet(payload);
  },
);

export const resetSignStudentAttendanceSheet = createAction("student/resetSignAttendanceSheet");
